import { render, staticRenderFns } from "./FooterRecruit.vue?vue&type=template&id=59f1f82a&scoped=true"
import script from "./FooterRecruit.vue?vue&type=script&lang=js"
export * from "./FooterRecruit.vue?vue&type=script&lang=js"
import style0 from "./FooterRecruit.vue?vue&type=style&index=0&id=59f1f82a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f1f82a",
  null
  
)

export default component.exports